import { useEffect, useState } from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";

export default function CountUp({ value = 0, duration = 1.4, suffix = "", prefix = "", className = "" }) {
  const mv = useMotionValue(0);
  const rounded = useTransform(mv, (v) => Math.round(v));
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const ctrl = animate(mv, value, { duration, ease: [0.22, 1, 0.36, 1] });
    const unsub = rounded.on("change", (v) => setDisplay(v));
    return () => { ctrl.stop(); unsub(); };
  }, [value, duration, mv, rounded]);

  return <motion.span className={className}>{prefix}{display.toLocaleString()}{suffix}</motion.span>;
}
